var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 125,
    viewBox: "0 0 124 125",
    width: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m62.0004 112.1c27.3933 0 49.5996-22.2067 49.5996-49.6s-22.2063-49.6-49.5996-49.6-49.6 22.2067-49.6 49.6 22.2067 49.6 49.6 49.6zm22.984-57.6159c2.4213-2.4213 2.4213-6.3469 0-8.7681-2.4212-2.4213-6.3468-2.4213-8.7681 0l-20.4159 20.4159-8.016-8.0159c-2.4212-2.4213-6.3468-2.4213-8.7681 0-2.4212 2.4212-2.4212 6.3468 0 8.7681l12.4 12.4c2.4213 2.4212 6.3469 2.4212 8.7681 0z",
    fill: "#00b574",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSuccess);
export default __webpack_public_path__ + "static/media/circle-success.6cd4292890066b3cc13d4fc96e23475f.svg";
export { ForwardRef as ReactComponent };